import { IndividualType } from 'store/individuals/individual';
import { RolesWithPermissions } from './types';
import { User } from 'store/session/user';

export const ROLES: RolesWithPermissions = {
    [IndividualType.SUPER_ADMIN]: {
        manifests: { CREATE: true, READ: true, UPDATE: true, ARCHIVE: true, UPDATE_EXTERNAL_REFERENCES: true },
        jobs: { CREATE: true, READ: true, UPDATE: true, ARCHIVE: true, UPDATE_EXTERNAL_REFERENCES: true },
        declarations: { CREATE: true, READ: true, UPDATE: true, ARCHIVE: true },
        templates: { CREATE: true, READ: true, UPDATE: true, ARCHIVE: true },
        notes: { CREATE: true, READ: true, UPDATE: true, ARCHIVE: true },
        teams: { CREATE: true, READ: true, UPDATE: true, ARCHIVE: true },
        teamMembers: { CREATE: true, READ: true, UPDATE: true, ARCHIVE: true },
        customers: { CREATE: true, READ: true, UPDATE: true, ARCHIVE: true },
        invoices: { CREATE: true, READ: true, UPDATE: true, ARCHIVE: true },
    },

    [IndividualType.BROKER_ADMIN]: {
        jobs: { CREATE: true, READ: true, UPDATE: true, ARCHIVE: true },
        declarations: { CREATE: true, READ: true, UPDATE: true, ARCHIVE: true },
        templates: { CREATE: true, READ: true, UPDATE: true, ARCHIVE: true },
        notes: { CREATE: true, READ: true, UPDATE: true, ARCHIVE: true },
        customers: { CREATE: true, READ: true, UPDATE: true, ARCHIVE: true },
    },

    [IndividualType.FREIGHT_FORWARDER_ADMIN]: {
        manifests: { CREATE: true, READ: true, UPDATE: true, ARCHIVE: true, UPDATE_EXTERNAL_REFERENCES: true },
        jobs: { CREATE: true, READ: true, UPDATE: true, ARCHIVE: true, UPDATE_EXTERNAL_REFERENCES: true },
        declarations: { CREATE: true, READ: true, UPDATE: true, ARCHIVE: true, DELETE: true },
        templates: { CREATE: true, READ: true, UPDATE: true, ARCHIVE: true },
        notes: { CREATE: true, READ: true, UPDATE: true, ARCHIVE: true },
        teams: { CREATE: true, READ: true, UPDATE: true, ARCHIVE: true },
        teamMembers: { CREATE: true, READ: true, UPDATE: true, ARCHIVE: true },
        customers: { CREATE: true, READ: true, UPDATE: true, ARCHIVE: true },
        invoices: { CREATE: true, READ: true, UPDATE: true, ARCHIVE: true },
    },

    [IndividualType.TEAM_MANAGER]: {
        manifests: { CREATE: true, READ: true, UPDATE: true, ARCHIVE: true, UPDATE_EXTERNAL_REFERENCES: true },
        jobs: { CREATE: true, READ: true, UPDATE: true, ARCHIVE: true, UPDATE_EXTERNAL_REFERENCES: true },
        declarations: { CREATE: true, READ: true, UPDATE: true, ARCHIVE: true, DELETE: true },
        templates: { CREATE: true, READ: true, UPDATE: true, ARCHIVE: true },
        notes: {
            CREATE: true,
            READ: true,
            UPDATE: true,
        },
        teams: {
            CREATE: true,
            READ: true,
        },
        // Team Manager is allowed to udpate team members in Teams
        teamMembers: {
            CREATE: true,
            READ: true,
            UPDATE: true,
        },
        customers: { CREATE: true, READ: true, UPDATE: true, ARCHIVE: true },
        invoices: { READ: true },
    },

    [IndividualType.JOB_MANAGER]: {
        manifests: { CREATE: true, READ: true, UPDATE: true, ARCHIVE: true, UPDATE_EXTERNAL_REFERENCES: true },
        jobs: { CREATE: true, READ: true, UPDATE: true, ARCHIVE: true, UPDATE_EXTERNAL_REFERENCES: true },
        declarations: { CREATE: true, READ: true, UPDATE: true, ARCHIVE: true, DELETE: true },
        templates: { CREATE: true, READ: true, UPDATE: true, ARCHIVE: true },

        notes: {
            CREATE: true,
            READ: true,
        },
        customers: { CREATE: true, READ: true, UPDATE: true, ARCHIVE: true },
        invoices: { READ: true },
    },

    [IndividualType.CLEARANCE_AGENT]: {
        manifests: { CREATE: true, READ: true, UPDATE: true, ARCHIVE: true, UPDATE_EXTERNAL_REFERENCES: true },
        jobs: { CREATE: true, READ: true, UPDATE: true, ARCHIVE: true, UPDATE_EXTERNAL_REFERENCES: true },
        declarations: { CREATE: true, READ: true, UPDATE: true, DELETE: true, ARCHIVE: true },
        templates: { CREATE: true, READ: true, UPDATE: true, ARCHIVE: true },
        notes: {
            CREATE: true,
            READ: true,
        },
        teams: {
            READ: true,
        },
        customers: { CREATE: true, READ: true, UPDATE: true, ARCHIVE: true },
        invoices: { READ: true },
    },

    [IndividualType.ACCOUNTS_MANAGER]: {
        manifests: { READ: true },
        jobs: { READ: true },
        declarations: { READ: true },
        templates: { READ: true },
        notes: { READ: true },
        teams: { READ: true },
        customers: { CREATE: true, READ: true, UPDATE: true },
        invoices: { CREATE: true, READ: true, UPDATE: true, ARCHIVE: true },
    },
};

export const FREIGHT_FORWARDER_ROLES: IndividualType[] = [
    IndividualType.FREIGHT_FORWARDER_ADMIN,
    IndividualType.TEAM_MANAGER,
    IndividualType.JOB_MANAGER,
    IndividualType.CLEARANCE_AGENT,
    IndividualType.ACCOUNTS_MANAGER,
];

export const TEAMS_ACCESS_ROLES: IndividualType[] = [IndividualType.SUPER_ADMIN, ...FREIGHT_FORWARDER_ROLES];

export const MANIFESTS_ACCESS_ROLES: Record<'READ' | 'CREATE', IndividualType[]> = {
    READ: [IndividualType.SUPER_ADMIN, ...FREIGHT_FORWARDER_ROLES],
    CREATE: [
        IndividualType.SUPER_ADMIN,
        IndividualType.FREIGHT_FORWARDER_ADMIN,
        IndividualType.TEAM_MANAGER,
        IndividualType.JOB_MANAGER,
        IndividualType.CLEARANCE_AGENT,
    ],
};

export const JOBS_ACCESS_ROLES: Record<'READ' | 'CREATE', IndividualType[]> = {
    READ: [
        IndividualType.SUPER_ADMIN,
        IndividualType.BROKER_ADMIN,
        IndividualType.BROKER_CLERK,
        IndividualType.SYSTEM_ADMIN,
        IndividualType.TRADER_ADMIN,
        IndividualType.TRADER_USER,
        IndividualType.HAULIER_ADMIN,
        IndividualType.TENANT_OWNER,
        ...FREIGHT_FORWARDER_ROLES,
    ],
    CREATE: [
        IndividualType.SUPER_ADMIN,
        IndividualType.BROKER_ADMIN,
        IndividualType.BROKER_CLERK,
        IndividualType.SYSTEM_ADMIN,
        IndividualType.TRADER_ADMIN,
        IndividualType.TRADER_USER,
        IndividualType.HAULIER_ADMIN,
        IndividualType.TENANT_OWNER,
        IndividualType.FREIGHT_FORWARDER_ADMIN,
        IndividualType.TEAM_MANAGER,
        IndividualType.JOB_MANAGER,
        IndividualType.CLEARANCE_AGENT,
    ],
};

export const DECLARATIONS_ACCESS_ROLES: IndividualType[] = [
    IndividualType.SUPER_ADMIN,
    IndividualType.BROKER_ADMIN,
    IndividualType.BROKER_CLERK,
    IndividualType.SYSTEM_ADMIN,
    IndividualType.TRADER_ADMIN,
    IndividualType.TRADER_USER,
    ...FREIGHT_FORWARDER_ROLES,
];

export const TEMPLATES_ACCESS_ROLES: IndividualType[] = [
    IndividualType.SUPER_ADMIN,
    IndividualType.BROKER_ADMIN,
    IndividualType.HAULIER_ADMIN,
    IndividualType.SYSTEM_ADMIN,
    IndividualType.TRADER_ADMIN,
    ...FREIGHT_FORWARDER_ROLES,
];

export const USER_MANAGEMENT_ACCESS_ROLES: IndividualType[] = [
    IndividualType.SUPER_ADMIN,
    IndividualType.BROKER_ADMIN,
    IndividualType.HAULIER_ADMIN,
    IndividualType.SYSTEM_ADMIN,
    IndividualType.TRADER_ADMIN,
    IndividualType.FREIGHT_FORWARDER_ADMIN,
    IndividualType.TEAM_MANAGER,
];

export const COMPANY_DETAILS_ACCESS_ROLES: IndividualType[] = [
    IndividualType.SUPER_ADMIN,
    IndividualType.BROKER_ADMIN,
    IndividualType.HAULIER_ADMIN,
    IndividualType.SYSTEM_ADMIN,
    IndividualType.TRADER_ADMIN,
    IndividualType.FREIGHT_FORWARDER_ADMIN,
];

export const INVOICES_ACCESS_ROLES: Record<'SINGLE' | 'DASHBOARD' | 'CONFIG', IndividualType[]> = {
    SINGLE: [...FREIGHT_FORWARDER_ROLES, IndividualType.SUPER_ADMIN],
    DASHBOARD: [IndividualType.SUPER_ADMIN, IndividualType.FREIGHT_FORWARDER_ADMIN, IndividualType.ACCOUNTS_MANAGER],
    CONFIG: [IndividualType.SUPER_ADMIN, IndividualType.FREIGHT_FORWARDER_ADMIN, IndividualType.ACCOUNTS_MANAGER],
};

export const SHIPMENTS_ACCESS_ROLES: IndividualType[] = [
    IndividualType.SUPER_ADMIN,
    IndividualType.SYSTEM_ADMIN,
    IndividualType.BROKER_ADMIN,
    IndividualType.BROKER_CLERK,
];

export const TEAM_ROLES = [IndividualType.TEAM_MANAGER, IndividualType.JOB_MANAGER, IndividualType.CLEARANCE_AGENT];

// Every Freight Forwarder role is allowed to assign jobs (unless role is ACCOUNTS MANAGER)
export const checkCanAssignJobs = (userInfo?: User): boolean => {
    const role = userInfo?.role;
    if (!role) return false;
    return FREIGHT_FORWARDER_ROLES.includes(role) && role === IndividualType.ACCOUNTS_MANAGER;
};

export const checkIsFreightAdmin = (userInfo?: User): boolean => {
    return Boolean(!!userInfo && userInfo.role === IndividualType.FREIGHT_FORWARDER_ADMIN);
};

export const checkIsClearanceAgent = (userInfo?: User): boolean => {
    if (!userInfo?.role) return false;
    return Boolean(!!userInfo && userInfo.role === IndividualType.CLEARANCE_AGENT);
};

export const checkIsFreightForwarder = (userInfo?: User): boolean => {
    if (!userInfo?.role) return false;
    return FREIGHT_FORWARDER_ROLES.includes(userInfo?.role);
};

export const checkIsAccountsAssociate = (userInfo?: User): boolean => {
    if (!userInfo?.role) return false;
    return Boolean(!!userInfo && userInfo.role === IndividualType.ACCOUNTS_MANAGER);
};
